import { useState } from 'react';
import { bugReportClient } from '../../lib/connect/clients';
const toBytes = async (blob)=>blob ? new Uint8Array(await blob.arrayBuffer()) : undefined;
export function useBugReport() {
    const [isLoading, setIsLoading] = useState(false);
    const submitBugReport = async (data)=>{
        setIsLoading(true);
        try {
            // The screenshot travels as bytes rather than multipart. mainmast files
            // the report as a Jira issue and attaches it there, so there is no
            // upload endpoint to post a form to — and a screenshot is small enough
            // that a second round-trip would only add a thing to fail.
            const screenshot = await toBytes(data.screenshot);
            // userInfo is no longer sent: mainmast takes the reporter from the
            // gateway principal, so a caller-supplied identity would be ignored at
            // best and misleading at worst.
            const response = await bugReportClient.createBugReport({
                title: data.title,
                description: data.description,
                pageUrl: data.pageUrl,
                browserInfo: data.browserInfo,
                timestamp: data.timestamp,
                appState: data.appState ?? '',
                screenshot,
                screenshotFilename: data.screenshot?.name ?? '',
                audio: await toBytes(data.audio),
                audioFilename: data.audioFilename ?? '',
                transcript: data.transcript ?? ''
            });
            return {
                ticketNumber: response.jiraTicketNumber || 'SDS-UNKNOWN',
                bugReportID: response.jiraTicketNumber,
                message: `Reported as ${response.jiraTicketNumber}`
            };
        } finally{
            setIsLoading(false);
        }
    };
    // Drafting is not wrapped in isLoading: that flag drives the submit button,
    // and the dialog shows its own "transcribing" state beside the mic.
    const draftBugReport = async ({ audio, filename })=>{
        const response = await bugReportClient.draftBugReport({
            audio: await toBytes(audio),
            audioFilename: filename,
            pageUrl: window.location.href
        });
        return {
            transcript: response.transcript,
            title: response.title,
            description: response.description
        };
    };
    return {
        submitBugReport,
        draftBugReport,
        isLoading
    };
}
